import { render } from "./common-mce-editor.vue?vue&type=template&id=0273f0f9&scoped=true"
import script from "./common-mce-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./common-mce-editor.vue?vue&type=script&setup=true&lang=js"

import "./common-mce-editor.vue?vue&type=style&index=0&id=0273f0f9&scoped=true&lang=css"
import "./common-mce-editor.vue?vue&type=style&index=1&id=0273f0f9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0273f0f9"],['__file',"src/components/common/common-mce-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0273f0f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0273f0f9', __exports__)) {
    api.reload('0273f0f9', __exports__)
  }
  
  module.hot.accept("./common-mce-editor.vue?vue&type=template&id=0273f0f9&scoped=true", () => {
    api.rerender('0273f0f9', render)
  })

}


export default __exports__